
export default [{
  path: '/share',
  name: 'share',
  component: () => import('@/views/wxshare/index'),
}]
